export default __webpack_public_path__ + "static/desk-banner-76a2a70f64b0c760c4b613b790581aca.png";